<template>
  <section class="pad-t-0 edit-promo-page">
    <div class="bb-container">
      <div class="back">
        <div class="back__back">
          <a @click.prevent="$router.back()">
            <div class="back__name">
              <img
                src="../../assets/img/ico/ico-arrow-back.svg"
                loading="lazy"
                alt="Volver"
                class="back__arrow"
              />
            </div>
          </a>
        </div>
      </div>

      <div class="g-edit" v-show="loaded">
        <div class="g-edit__header">
          <h1 class="g-edit__title">
            {{ isEdit ? "Editar promoción afiliada" : "Nueva promoción afiliada" }}
          </h1>
        </div>

        <div class="g-edit__cols">
          <div class="g-edit__content">
            <h3 class="g-edit__head header-4">Datos básicos</h3>

            <div class="edit-data">
              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Título *</div>
                  <input
                    v-model="form.title"
                    class="bb-form"
                    type="text"
                    maxlength="300"
                    @blur="touch('title')"
                  />
                  <div class="bb-form-error" v-show="hasError('title')">
                    Campo obligatorio
                  </div>
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Descripción</div>
                  <textarea
                    v-model="form.description"
                    class="bb-form-textarea"
                    rows="4"
                  />
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Mercado (ISO2) *</div>
                  <select v-model="form.marketCountryIso2" class="bb-form" @blur="touch('marketCountryIso2')">
                    <option disabled value="">Selecciona...</option>
                    <option v-for="m in markets" :key="m" :value="m">{{ m }}</option>
                  </select>
                  <div class="bb-form-error" v-show="hasError('marketCountryIso2')">
                    Campo obligatorio
                  </div>
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Retailer *</div>
                  <input
                    v-model="form.retailerName"
                    class="bb-form"
                    type="text"
                    maxlength="200"
                    placeholder="Ej: Vertbaudet"
                    @blur="touch('retailerName')"
                  />
                  <div class="bb-form-error" v-show="hasError('retailerName')">
                    Campo obligatorio
                  </div>
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Red afiliación</div>
                  <select v-model="form.affiliateNetwork" class="bb-form">
                    <option value="">(vacío)</option>
                    <option v-for="n in affiliateNetworks" :key="n" :value="n">{{ n }}</option>
                  </select>
                </div>
              </div>
            </div>

            <h3 class="g-edit__head header-4 mar-t-2">Cupón y enlace</h3>

            <div class="edit-data">
              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Tipo cupón</div>
                  <select v-model="form.couponType" class="bb-form">
                    <option value="code">Código</option>
                    <!-- <option value="auto">Automático</option> -->
                    <option value="none">Sin cupón</option>
                  </select>
                </div>
              </div>

              <div class="edit-data__item" v-if="form.couponType === 'code'">
                <div class="bb-form-item">
                  <div class="bb-form-label">Código cupón</div>
                  <input
                    v-model="form.couponCode"
                    class="bb-form"
                    type="text"
                    maxlength="100"
                    placeholder="Ej: VERANO20"
                  />
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Link (landing)</div>
                  <div class="bb-form-group">
                    <input
                      v-model="form.linkUrl"
                      class="bb-form"
                      type="text"
                      maxlength="800"
                      placeholder="https://..."
                    />
                    <a
                      v-if="isValidUrl(form.linkUrl)"
                      :href="form.linkUrl"
                      target="_blank"
                      class="bb-form-group__ico"
                      rel="noopener"
                    >
                      <img src="../../assets/img/ico/ico-external-link.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <h3 class="g-edit__head header-4 mar-t-2">Alcance y mecánica</h3>

            <div class="edit-data">
              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Scope</div>
                  <select v-model="form.scope" class="bb-form">
                    <option value="retailer">Toda la tienda</option>
                    <option value="product_group">Grupo de productos</option>
                    <option value="conditional">Condiciones especiales</option>
                  </select>
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Tipo de promo</div>
                  <select v-model="form.promotionType" class="bb-form">
                    <option value="unknown">Desconocido</option>
                    <option value="percentage">Porcentaje</option>
                    <option value="fixed_amount">Importe fijo</option>
                    <option value="free_gift">Regalo</option>
                    <option value="shipping">Envío</option>
                    <option value="sale">Rebajas</option>
                  </select>
                </div>
              </div>

              <div class="edit-data__item" v-if="form.promotionType === 'percentage'">
                <div class="bb-form-item">
                  <div class="bb-form-label">% descuento</div>
                  <input v-model.number="form.discountPercent" class="bb-form" type="number" step="0.01" min="0" max="100" />
                </div>
              </div>

              <div class="edit-data__item" v-if="form.promotionType === 'fixed_amount'">
                <div class="bb-form-item">
                  <div class="bb-form-label">Descuento (importe)</div>
                  <input v-model.number="form.discountAmount" class="bb-form" type="number" step="0.01" min="0" />
                </div>
              </div>

              <div class="edit-data__item" v-if="form.promotionType === 'free_gift'">
                <div class="bb-form-item">
                  <div class="bb-form-label">Descripción del regalo</div>
                  <input v-model="form.freeGiftDescription" class="bb-form" type="text" maxlength="500" />
                </div>
              </div>

              <div class="edit-data__item" v-if="form.promotionType === 'shipping'">
                <div class="bb-form-item">
                  <div class="bb-form-label">Descripción del envío</div>
                  <input v-model="form.shippingDescription" class="bb-form" type="text" maxlength="500" />
                </div>
              </div>
            </div>

            <h3 class="g-edit__head header-4 mar-t-2">Condiciones</h3>

            <div class="edit-data">
              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Pedido mínimo</div>
                  <input v-model.number="form.minOrderValue" class="bb-form" type="number" step="0.01" min="0" />
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Cantidad mínima</div>
                  <input v-model.number="form.minQuantity" class="bb-form" type="number" step="1" min="0" />
                </div>
              </div>

              <div class="edit-data__item" v-show=false>
                <div class="bb-form-item">
                  <label class="bb-form-checkbox">
                    <input type="checkbox" v-model="form.newCustomersOnly" />
                    <span>Solo nuevos usuarios</span>
                  </label>
                </div>
              </div>

              <div class="edit-data__item" v-show="false">
                <div class="bb-form-item">
                  <label class="bb-form-checkbox">
                    <input type="checkbox" v-model="form.requiresLoyaltyCard" />
                    <span>Requiere tarjeta fidelidad</span>
                  </label>
                </div>
              </div>
            </div>

            <h3 class="g-edit__head header-4 mar-t-2" v-show="false">Restricciones (opcional)</h3>

            <div class="edit-data" v-show="false">
              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Grupo productos (texto)</div>
                  <input v-model="form.productGroupText" class="bb-form" type="text" maxlength="200" />
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Keywords (texto libre)</div>
                  <input v-model="form.keywords" class="bb-form" type="text" maxlength="500" placeholder="Ej: electronica, skincare, beats" />
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Tipo de lista afectada</div>
                  <select v-model="form.appliesToListTypes" class="bb-form">
                    <option value="any">Any</option>
                    <option value="baby_registry">Baby registry</option>
                  </select>
                </div>
              </div>
            </div>

            <h3 class="g-edit__head header-4 mar-t-2">Vigencia y estado</h3>

            <div class="edit-data">
              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Inicio</div>
                  <input v-model="form.startAt" class="bb-form" type="date" />
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Fin</div>
                  <input v-model="form.endAt" class="bb-form" type="date" />
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Estado</div>
                  <select v-model="form.status" class="bb-form">
                    <option value="active">Activa</option>
                    <!-- <option value="scheduled">Programada</option> -->
                    <!-- <option value="expired">Caducada</option> -->
                    <option value="disabled">Desactivada</option>
                    <option value="deleted">Eliminada</option>
                  </select>
                </div>
              </div>

              <div class="edit-data__item">
                <div class="bb-form-item">
                  <div class="bb-form-label">Notas internas</div>
                  <textarea v-model="form.notesInternal" class="bb-form-textarea" rows="3" />
                </div>
              </div>
            </div>

            <div class="g-edit__actions-column">
              <loading-button v-if="saving"></loading-button>

              <button
                v-else
                class="button button--primary button--block"
                @click.prevent="save"
                :disabled="disabled"
              >
                Guardar
              </button>

              <a @click.prevent="$router.back()">
                <button class="button button--secondary button--block">Cancelar</button>
              </a>
            </div>
          </div>

          <div class="g-edit__picture">
            <h3 class="g-edit__head header-4">Previsualización</h3>

            <div class="toast toast--aqua mar-b-1">
              <div class="toast__content">
                <div><strong>{{ form.retailerName || "Retailer" }}</strong> ({{ form.marketCountryIso2 || "XX" }})</div>
                <div class="mar-t-1">{{ form.title || "Título de la promoción" }}</div>
                <div v-if="form.couponType === 'code' && form.couponCode" class="mar-t-1">
                  <strong>Código:</strong> {{ form.couponCode }}
                </div>
                <div v-if="form.promotionType === 'percentage' && form.discountPercent != null" class="mar-t-1">
                  <strong>-{{ form.discountPercent }}%</strong>
                </div>
                <div v-if="form.promotionType === 'fixed_amount' && form.discountAmount != null" class="mar-t-1">
                  <strong>-{{ form.discountAmount }}</strong>
                </div>
                <div v-if="form.minOrderValue != null" class="mar-t-1">
                  <span>Pedido mínimo: {{ form.minOrderValue }}</span>
                </div>
                <div v-if="isValidUrl(form.linkUrl)" class="mar-t-1">
                  <a :href="form.linkUrl" target="_blank" rel="noopener">Ver oferta</a>
                </div>
              </div>
            </div>

            <div v-if="errorMsg" class="bb-form-error">
              {{ errorMsg }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loaded" class="mar-t-2">
        <loading-button></loading-button>
      </div>
    </div>
  </section>
</template>

<script>
import LoadingButton from "../../components/LoadingButton";
import { mapGetters } from "vuex";
import axios from "axios";

const API_BASE = process.env.API;

export default {
  name: "AdminAffiliatePromotionEditPage",
  components: { LoadingButton },
  data() {
    return {
      loaded: false,
      saving: false,
      errorMsg: null,
      touched: {},
      markets: ["ES", "FR", "IT", "PT", "DE", "NL", "BR", "MX"],
      affiliateNetworks: ["awin", "tradedoubler", "skimlinks", "effinity", "adtraction"],
      form: {
        title: "",
        description: "",
        marketCountryIso2: "",
        retailerName: "",
        affiliateNetwork: "",

        couponCode: "",
        couponType: "code",
        linkUrl: "",

        scope: "retailer",
        promotionType: "unknown",
        discountPercent: null,
        discountAmount: null,
        freeGiftDescription: "",
        shippingDescription: "",

        minOrderValue: null,
        minQuantity: null,
        newCustomersOnly: false,
        requiresLoyaltyCard: false,

        productGroupText: "",
        keywords: "",

        appliesToListTypes: "any",

        // datetime-local expects "YYYY-MM-DDTHH:mm"
        startAt: "",
        endAt: "",

        status: "active",
        notesInternal: "",
      },
    };
  },
  computed: {
    ...mapGetters({ auth_token: "auth_token" }),
    isEdit() {
      return !!this.$route.params.id;
    },
    disabled() {
      return (
        this.saving ||
        !this.form.title ||
        !this.form.marketCountryIso2 ||
        !this.form.retailerName
      );
    },
  },
  methods: {
    touch(field) {
      this.$set(this.touched, field, true);
    },
    hasError(field) {
      if (!this.touched[field]) return false;
      if (field === "title") return !this.form.title;
      if (field === "marketCountryIso2") return !this.form.marketCountryIso2;
      if (field === "retailerName") return !this.form.retailerName;
      return false;
    },
    isValidUrl(value) {
      if (!value) return false;
      try {
        new URL(value);
        return true;
      } catch {
        return false;
      }
    },

    toDateInputValue(iso) {
      if (!iso) return "";
      // iso: "2026-03-10T00:00:00Z" -> "2026-03-10"
      return String(iso).substring(0, 10);
    },

    fromDateStart(value) {
      if (!value) return null;
      const [y, m, d] = value.split("-").map(Number);
      const dt = new Date(y, m - 1, d, 0, 0, 0, 0); // local start of day
      return dt.toISOString();
    },

    fromDateEnd(value) {
      if (!value) return null;
      const [y, m, d] = value.split("-").map(Number);
      const dt = new Date(y, m - 1, d, 23, 59, 59, 999); // local end of day
      return dt.toISOString();
    },

    async load() {
      if (!this.isEdit) {
        this.loaded = true;
        return;
      }

      try {
        const id = this.$route.params.id;
        const res = await axios.get(
          `${API_BASE}/admin/affiliate-promotions/${id}`,
          { headers: { Authorization: `Bearer ${this.auth_token}` } }
        );
        const p = res.data;

        // Map response -> form (si tus nombres cambian, ajusta aquí)
        this.form.title = p.title || "";
        this.form.description = p.description || "";
        this.form.marketCountryIso2 = p.marketCountryIso2 || "";
        this.form.retailerName = p.retailerName || "";
        this.form.affiliateNetwork = p.affiliateNetwork || "";

        this.form.couponCode = p.couponCode || "";
        this.form.couponType = p.couponType || "code";
        this.form.linkUrl = p.linkUrl || "";

        this.form.scope = p.scope || "retailer";
        this.form.promotionType = p.promotionType || "unknown";
        this.form.discountPercent = p.discountPercent ?? null;
        this.form.discountAmount = p.discountAmount ?? null;
        this.form.freeGiftDescription = p.freeGiftDescription || "";
        this.form.shippingDescription = p.shippingDescription || "";

        this.form.minOrderValue = p.minOrderValue ?? null;
        this.form.minQuantity = p.minQuantity ?? null;
        this.form.newCustomersOnly = !!p.newCustomersOnly;
        this.form.requiresLoyaltyCard = !!p.requiresLoyaltyCard;

        this.form.productGroupText = p.productGroupText || "";
        this.form.keywords = p.keywords || "";

        this.form.appliesToListTypes = p.appliesToListTypes || "any";

        this.form.startAt = this.toDateInputValue(p.startAt);
        this.form.endAt = this.toDateInputValue(p.endAt);

        this.form.status = p.status || "active";
        this.form.notesInternal = p.notesInternal || "";
      } catch (e) {
        this.errorMsg = "No se pudo cargar la promoción.";
        // Si tienes alert system:
        // this.$alert.error(this.errorMsg, "admin_affiliate_promo_edit");
        console.log(e);
      } finally {
        this.loaded = true;
      }
    },

    buildPayload() {
      // OJO: tu API espera DateTimeOffset? => mandamos ISO o null
      const payload = {
        ...this.form,
        startAt: this.fromDateStart(this.form.startAt),
        endAt: this.fromDateEnd(this.form.endAt),
      };

      // Si couponType != code, limpiamos couponCode para no guardar basura
      if (payload.couponType !== "code") payload.couponCode = null;

      // Si promotionType no aplica, limpiamos campos
      if (payload.promotionType !== "percentage") payload.discountPercent = null;
      if (payload.promotionType !== "fixed_amount") payload.discountAmount = null;
      if (payload.promotionType !== "free_gift") payload.freeGiftDescription = null;
      if (payload.promotionType !== "shipping") payload.shippingDescription = null;

      return payload;
    },

    async save() {
      this.errorMsg = null;
      this.touch("title");
      this.touch("marketCountryIso2");
      this.touch("retailerName");

      if (this.disabled) return;

      // Validación mínima de fechas
      const start = this.form.startAt ? new Date(this.fromDateStart(this.form.startAt)) : null;
      const end = this.form.endAt ? new Date(this.fromDateEnd(this.form.endAt)) : null;

      if (start && end && end < start) {
        this.errorMsg = "La fecha de fin no puede ser anterior a la de inicio.";
        return;
      }

      this.saving = true;

      try {
        const payload = this.buildPayload();

        if (this.isEdit) {
          const id = this.$route.params.id;
          await axios.put(`${API_BASE}/admin/affiliate-promotions/${id}`, payload, { headers: { Authorization: `Bearer ${this.auth_token}` } });
        } else {
          await axios.post(`${API_BASE}/admin/affiliate-promotions`, payload, { headers: { Authorization: `Bearer ${this.auth_token}` } });
        }

        // Si usas tu sistema de alertas:
        // window.localStorage.setItem("alertMessage", "Guardado correctamente");
        // this.$alert.success("Guardado correctamente", "admin_affiliate_promo_edit");
        await this.$router.back();
      } catch (e) {
        this.errorMsg = "No se pudo guardar la promoción.";
        console.log(e);
      } finally {
        this.saving = false;
      }
    },
  },
  async mounted() {
    await this.load();
  },
};
</script>
